import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import '@fontsource-variable/fredoka/wght.css'
import '@fontsource-variable/nunito/wght.css'
// La firma del fundador se escribe a mano (§0056).
import '@fontsource/caveat/600.css'

import './design-system/tokens.css'
import './design-system/base.css'

import { router } from './app/router'
import { Providers } from './app/providers'
import { ErrorBoundary } from './app/ErrorBoundary'
import { initTheme } from './stores/theme'
import { initSession } from './stores/session'
import { initQueue } from './features/offline/queue'
import { registerServiceWorker } from './features/offline/sw-registration'
import { initInstallPrompt } from './features/onboarding/install'

initTheme()
initSession()
initQueue()
registerServiceWorker()
initInstallPrompt()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  </StrictMode>,
)
